import { executeGetRequest } from "@api/client";
import { apiPath } from "@routes/api";

export const getYoutubeVideos = async (lang: string) => {
  const [promise] = executeGetRequest(apiPath.youtubeVideos, lang);
  const result: any = await promise;
  return result.data;
};
